import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PLAYER_TURN_USERNAME_ANIMATION_SET } from '../../../animations/animationDefinitions';
import { useAppSelector } from '../../../redux/store';
import { AnimationContainer } from '../pixiComponents/animationContainer';
export const UsernameBadgeAnimationWrapper = ({ seatIndex, children }) => {
    const animationStartTimestampMs = useAppSelector((state) => {
        const isActiveTimerSeat = !!state.poker.actionTimer?.seatIndexes.includes(seatIndex);
        if (!isActiveTimerSeat) {
            return;
        }
        return state.poker.actionTimer?.startTimestampMs;
    });
    if (animationStartTimestampMs === undefined) {
        return children;
    }
    return (_jsx(AnimationContainer, { animationSet: PLAYER_TURN_USERNAME_ANIMATION_SET, startTimestampMs: animationStartTimestampMs, children: children }));
};
